{
  "move_node": {
    "title": "Elige una nueva ubicación para el {{ nodeType }}",
    "multi_title": "Elige una nueva ubicación para los {{ count }} artículos seleccionados",
    "empty_title": "Elige una nueva ubicación",
    "success": "Los artículos se movieron correctamente.",
    "multiple_items": "Varios artículos",
    "no_permission_tooltip": "No tienes permiso para mover elementos a esta ubicación"
  },
  "permissions": {
    "request_access": "Solicita acceso",
    "no_read_permissions": "No tienes permisos de lectura para este artículo",
    "no_write_permissions": "No tiene permisos de escritura en este elemento"
  },
  "mappingLibraries": {
    "My Workspace": "Mi espacio de trabajo",
    "My workspace": "Mi espacio de trabajo",
    "Team Workspace": "Espacio de trabajo en equipo",
    "Team workspace": "Espacio de trabajo en equipo",
    "Shared library": "Espacio de trabajo en equipo",
    "Recently viewed": "Visto recientemente",
    "Recently Viewed": "Visto recientemente",
    "Favourites": "Favoritos",
    "add_to_favourites": "añadir a favoritos",
    "remove_from_favourites": "eliminar de favoritos"
  },
  "copy_node": {
    "button": "Copia {{ nodeType }}",
    "title": "Elige una ubicación para copiar el {{ nodeType }}",
    "multi_title": "Elige una ubicación para copiar los elementos seleccionados",
    "empty_title": "Elige una ubicación",
    "success": "Los artículos se copiaron correctamente.",
    "multiple_items": "Varios artículos",
    "no_permission_tooltip": "No tienes permiso para copiar elementos a esta ubicación",
    "copy_with_map_objects": "Copiar objetos del mapa",
    "options_title": "Opciones de copia",
    "options_submit_button": "Copiar",
    "options_description": {
      "map_objects_only": "Elija si desea incluir los objetos del mapa al copiarlos.",
      "map_objects_and_permissions": "Elija si desea incluir los objetos del mapa y los permisos al copiar."
    }
  },
  "delete_node": {
    "selected_items_cannot_be_deleted": "No puede eliminar los elementos seleccionados"
  },
  "create_node": {
    "change_location": "Cambiar ubicación"
  }
}